import { ProductCatalogueProduct } from "./ProductCatalogueProduct";

export class ProductCatalogue {
    id: string;
    name: string;
    description?: string;
    products?: ProductCatalogueProduct[];
}